import type {FormInstance} from 'antd';

/** Clears Ant Design field errors without running validators. */
export const clearPCFFormValidation = (form: FormInstance): void => {
  const fieldsWithErrors = form
    .getFieldsError()
    .filter(({errors}) => errors.length > 0);

  if (fieldsWithErrors.length === 0) {
    return;
  }

  form.setFields(
    fieldsWithErrors.map(({name}) => ({
      name,
      errors: []
    }))
  );
};

/** Persist draft without running form validation. */
export const runPCFDraftSave = async (
  form: FormInstance,
  save: () => Promise<void>
): Promise<void> => {
  await save();
  clearPCFFormValidation(form);
};
